import communicate from 'src/api/communicate';
import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import dayjs from 'dayjs';
import { loadExcelExport } from 'src/store/actions/excelActions';
import { fetchUserConfirmationStatuses } from 'src/store/actions/confirmationsActions';
import store from 'src/store';
import { selectIsModuleEnabled } from 'src/store/selectors/configurations';
export var DetailedSummaryReportActionTypes;
(function (DetailedSummaryReportActionTypes) {
    DetailedSummaryReportActionTypes["SAVE_DETAILED_SUMMARY_REPORT"] = "SAVE_DETAILED_SUMMARY_REPORT";
    DetailedSummaryReportActionTypes["LOADING_DETAILED_SUMMARY_REPORT"] = "LOADING_DETAILED_SUMMARY_REPORT";
    DetailedSummaryReportActionTypes["NOT_LOADING_DETAILED_SUMMARY_REPORT"] = "NOT_LOADING_DETAILED_SUMMARY_REPORT";
    DetailedSummaryReportActionTypes["UPDATE_DETAILED_SUMMARY_REPORT_UI_CONFIG"] = "UPDATE_DETAILED_SUMMARY_REPORT_UI_CONFIG";
})(DetailedSummaryReportActionTypes || (DetailedSummaryReportActionTypes = {}));
export function saveDetailedSummaryReport(rawReport, mainReportConfirmations) {
    return {
        type: DetailedSummaryReportActionTypes.SAVE_DETAILED_SUMMARY_REPORT,
        payload: {
            rawReport,
            mainReportConfirmations
        }
    };
}
export function loadingDetailedSummaryReport() {
    return {
        type: DetailedSummaryReportActionTypes.LOADING_DETAILED_SUMMARY_REPORT
    };
}
export function notLoadingDetailedSummaryReport() {
    return {
        type: DetailedSummaryReportActionTypes.NOT_LOADING_DETAILED_SUMMARY_REPORT
    };
}
export function updateUIConfig(updatedConfigProps) {
    return {
        type: DetailedSummaryReportActionTypes.UPDATE_DETAILED_SUMMARY_REPORT_UI_CONFIG,
        payload: updatedConfigProps
    };
}
export function fetchDetailedSummaryReport(params) {
    return communicate({
        method: 'get',
        url: 'Reports/DetailedSummaryReport',
        getParams: Utils.objects.getQueryStringFromObject(params)
    });
}
export function loadDetailedSummaryReport(params) {
    return (dispatch) => {
        dispatch(loadingDetailedSummaryReport());
        const isMainReportEnabled = selectIsModuleEnabled(store.getState(), 'MainReport');
        const requests = [
            fetchDetailedSummaryReport(params),
            isMainReportEnabled ? fetchUserConfirmationStatuses({ period: params.period }) : Promise.resolve()
        ];
        return Promise.all(requests)
            .then(([report, mainReportConfirmations]) => {
            const reportData = report?.data?.Data;
            const confirmationsData = mainReportConfirmations?.data?.Data || [];
            dispatch(saveDetailedSummaryReport(reportData, confirmationsData));
            return reportData;
        })
            .catch((error) => {
            dispatch(notLoadingDetailedSummaryReport());
            toastrError(error);
            return Promise.reject(error);
        });
    };
}
export function loadExcel(params) {
    return (dispatch) => {
        const request = {
            url: 'Reports/DetailedSummaryReportExcel',
            query: Utils.objects.getQueryStringFromObject({
                ...params,
                currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss')
            })
        };
        return dispatch(loadExcelExport(request));
    };
}
